import { Button, Input, List, message as toast, Modal } from "antd";
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import "./index.less";
import { debounce } from "lodash";
import ReactDOM from "react-dom";

const { TextArea } = Input;

function RefusalCause({
  callbackFuc,
  removeNode
}: {
  callbackFuc: Function;
  removeNode: Function;
}) {
  const [t] = useTranslation("chat");
  const [regularRefusalCause, setRegularRefusalCause] = useState<string>("");
  // const [visible, setVisible] = useState(true);
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    removeNode?.();
  };
  const onOk = async (regularRefusalCause: string) => {
    setLoading(true);
    await callbackFuc({
      rejectReason: regularRefusalCause?.trim()
    });
    setLoading(false);
    handleClose();
  };
  const onChangeRefusalCause = (e: any) => {
    console.log("onChangeRefusalCause", e.target.value);
    setRegularRefusalCause(e.target.value || "");
  };

  return (
    <Modal
      title="驳回原因"
      centered={true}
      visible={true}
      onCancel={() => {
        handleClose();
      }}
      footer={
        <>
          <Button
            size="middle"
            onClick={() => {
              handleClose();
            }}
          >
            {t("cancelText")}
          </Button>
          <Button
            type="primary"
            size="middle"
            loading={loading}
            onClick={debounce(() => {
              onOk(regularRefusalCause);
            }, 500)}
          >
            {t("confirm")}
          </Button>
        </>
      }
    >
      <div className="regular-refusal-cause">
        <TextArea
          placeholder={t("请输入驳回原因")}
          rows={4}
          value={regularRefusalCause}
          onChange={onChangeRefusalCause}
          maxLength={100}
        />
        <p className="refusal-cause-length">
          <span>{regularRefusalCause.length || 0}</span>
          /100
        </p>
      </div>
    </Modal>
  );
}
interface RefuseModalProps {
  callbackFuc: Function;
}
export default function showRefuseModal(props: RefuseModalProps) {
  const ele = document.createElement("div");
  document.body.appendChild(ele);
  function removeNode() {
    if (ele) {
      ReactDOM.unmountComponentAtNode(ele);
      ele.remove();
    }
  }
  ReactDOM.render(<RefusalCause {...{ ...props }} removeNode={removeNode} />, ele);
}
